(() => {
  if (window.UcwPdpBundle) return;
  const pause = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds));
  async function items(section, variantId, quantity) {
    const placeholder = section.querySelector('[data-ucw-bundle-bridge] kaching-bundle');
    if (!placeholder) return [{ id: variantId, quantity }];
    let block = placeholder.querySelector('kaching-bundles-block');
    const deadline = Date.now() + 6000;
    while (!block && !placeholder.hasAttribute('data-initialized') && Date.now() < deadline) {
      await pause(50);
      block = placeholder.querySelector('kaching-bundles-block');
    }
    if (!block) {
      if (!document.getElementById('kaching-bundles-config') || placeholder.dataset.initialized === 'skipped') return [{ id: variantId, quantity }];
      throw new Error('De prijscontrole is nog niet klaar. Probeer het over enkele seconden opnieuw.');
    }
    block.setAttribute('current-variant-id', String(variantId));
    block.setAttribute('quantity', String(quantity));
    await pause(0);
    while (Date.now() < deadline) {
      if (typeof block.items === 'function') {
        const result = block.items();
        const valid = Array.isArray(result) && result.length > 0 && result.every(item => Number(item.id) === variantId && Number.isSafeInteger(item.quantity) && item.quantity > 0);
        if (valid && result.reduce((total, item) => total + item.quantity, 0) === quantity) {
          if (typeof block.validateItemSelection === 'function' && !block.validateItemSelection().valid) throw new Error('Controleer uw productkeuze voordat u bestelt.');
          block.rotateBundleNonce?.();
          await pause(0);
          const finalItems = block.items();
          if (finalItems.every(item => Number(item.id) === variantId) && finalItems.reduce((total, item) => total + item.quantity, 0) === quantity) return finalItems;
        }
      }
      await pause(25);
    }
    throw new Error('Uw gekozen aantal kon niet worden bevestigd. Er is niets toegevoegd. Probeer het opnieuw.');
  }
  window.UcwPdpBundle = Object.freeze({ items });
})();
